import _device from "./lib/device";
var exports = {};
var device_1 = _device;

exports = function supportsInputFormatting() {
  // Digits get dropped in samsung browser
  return !(0, device_1.isSamsungBrowser)();
};

export default exports;